import { render, staticRenderFns } from "./itemParam.vue?vue&type=template&id=2b469d74&"
import script from "./itemParam.vue?vue&type=script&lang=js&"
export * from "./itemParam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports